import { useDispatch } from 'react-redux';

import { logoutWithDelay } from 'store/oauth/service';

const useLogout = () => {
  const dispatch = useDispatch();

  const logout = () => {
    dispatch(logoutWithDelay());
  };

  return { logout };
};

export default useLogout;
